import { render, staticRenderFns } from "./MediaPreview.vue?vue&type=template&id=a6847624&lang=pug&"
import script from "./MediaPreview.vue?vue&type=script&lang=js&"
export * from "./MediaPreview.vue?vue&type=script&lang=js&"
import style0 from "./MediaPreview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jackie/sites/cardinalco/ylang-23/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a6847624')) {
      api.createRecord('a6847624', component.options)
    } else {
      api.reload('a6847624', component.options)
    }
    module.hot.accept("./MediaPreview.vue?vue&type=template&id=a6847624&lang=pug&", function () {
      api.rerender('a6847624', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/basic/MediaPreview.vue"
export default component.exports